import history from './history'

const useAppStack = () => {
  const navigationCountKey = 'navigationCount'

  const appStack = () => {
    const count = localStorage.getItem(navigationCountKey)
    if (count) {
      return parseInt(count)
    } else {
      return 0
    }
  }
  const setAppStack = (count: number) => {
    localStorage.setItem(navigationCountKey, count.toString())
  }

  const push = () => {
    const count = appStack() + 1
    setAppStack(count)
  }

  const pop = () => {
    if (appStack() > 0) {
      const count = appStack() - 1
      setAppStack(count)
      history?.goBack()
    }
  }

  return {
    push,
    pop,
    appStack,
  }
}

export default useAppStack
